// Cognito roles map to the backend `dynamodb.persons.user_role` column
// (MemberRole). These are distinct from the CASL-based RBAC roles assigned in
// this UI — they come from the identity provider and are read-only here. The
// raw user_role value is shown verbatim (no friendly relabeling).
export interface CognitoRoleOption {
  value: string
  label: string
}

const COGNITO_ROLE_VALUES: string[] = [
  'PlatformHixmeAdmin',
  'PlatformClientAdmin',
  'PlatformBroker',
  'HixmeReadOnlyAdmin',
  'PlatformHixmeSalesRep',
  'PlatformReadOnlyClientAdmin',
  'PlatformProspectAdmin',
]

export const COGNITO_ROLE_OPTIONS: CognitoRoleOption[] =
  COGNITO_ROLE_VALUES.map((value) => ({ value, label: value }))

export function formatCognitoRole(value: string): string {
  return value
}
